import React from "react";
import { useLanguage, T } from "@/lib/i18n";

export default function Footer() {
  const { lang } = useLanguage();
  return (
    <footer className="bg-sjm-ink text-white relative overflow-hidden grain" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-20 sm:py-28 relative z-10">
        <div className="font-display font-extrabold text-[12vw] sm:text-[8vw] lg:text-[6vw] leading-none tracking-tighter">
          {lang === "bn" ? "সংহতি।" : "Solidarity."}
        </div>
        <div className="mt-2 text-sjm-red font-display font-extrabold text-[12vw] sm:text-[8vw] lg:text-[6vw] leading-none tracking-tighter">
          {lang === "bn" ? "সংগ্রাম।" : "Struggle."}
        </div>
        <div className="mt-2 font-display font-extrabold text-[12vw] sm:text-[8vw] lg:text-[6vw] leading-none tracking-tighter">
          {lang === "bn" ? "জয়।" : "Victory."}
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-10 border-t border-white/15 pt-10 text-sm">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-sjm-red mb-3">{T.org_tag[lang]}</div>
            <div className={`font-display text-xl ${lang === "bn" ? "font-bn" : ""}`}>{T.org_name[lang]}</div>
            <p className="mt-3 text-white/70">{T.footer.line1[lang]}</p>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-white/60 mb-3">{T.contact.title[lang]}</div>
            <div className="text-white/80">{T.contact.address[lang]}</div>
            <div className="text-white/60 text-xs mt-2">sjm4bengal@gmail.com / sangramijouthamancha@gmail.com</div>
            <div className="text-white/60 text-xs mt-1">9332519733 / 9432364131</div>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-white/60 mb-3">© {new Date().getFullYear()}</div>
            <div className="text-white/60">{T.footer.rights[lang]}</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
